/**
 * PlaceholderPage — coming-soon screen for superadmin nav items not yet built.
 * Used by: Centres, Users, Finance, AI Monitor, System Config.
 * Props:
 *   pageName — display name of the section (e.g. "Finance")
 */

import React from 'react';
import { FiClock } from 'react-icons/fi';

// Per-page descriptions so the placeholder is informative, not generic.
const PHASE_NOTES = {
  'Centres':       'full centre roster, plan overrides, and usage analytics per tenant',
  'Users':         'cross-tenant user search, role management and impersonation audit trail',
  'Finance':       'platform MRR breakdown, payout ledger and Razorpay reconciliation',
  'AI monitor':    'agent session logs, token spend per tenant, and escalation heatmap',
  'System config': 'knowledge base editor, plan config editor and feature flag controls',
};

const PlaceholderPage = ({ pageName }) => {
  const note = PHASE_NOTES[pageName] || 'additional platform management tools';

  return (
    <div style={{
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      minHeight: '400px', textAlign: 'center', padding: '40px 24px',
    }}>
      {/* Teal clock icon */}
      <div style={{
        width: '64px', height: '64px', borderRadius: '16px',
        background: 'rgba(26,107,90,0.10)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        marginBottom: '20px',
      }}>
        <FiClock style={{ fontSize: '28px', color: '#1a6b5a' }} />
      </div>

      {/* Heading */}
      <div style={{ fontSize: '20px', fontWeight: '800', color: '#1a1a2e', marginBottom: '10px' }}>
        Coming soon
      </div>

      {/* Subtext */}
      <div style={{ fontSize: '13px', color: '#888', lineHeight: '1.7', maxWidth: '380px' }}>
        This section will cover {note}.
      </div>

      {/* Tag */}
      <div style={{
        marginTop: '28px',
        display: 'inline-flex', alignItems: 'center', gap: '6px',
        background: 'rgba(26,107,90,0.08)', borderRadius: '20px',
        padding: '6px 14px',
        fontSize: '11px', fontWeight: '600', color: '#1a6b5a',
      }}>
        <FiClock style={{ fontSize: '11px' }} />
        Coming soon
      </div>
    </div>
  );
};

export default PlaceholderPage;
